import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Skeltonshow ( { length, classes, width, height, baseColor } )
{
    return Array.from( { length } ).map( ( _, key ) => (
        <div className={ classes } key={ key }>
            <div className="mx-1">
                <Skeleton width={ width } height={ height } baseColor={ baseColor } />
            </div>
        </div>
    ) );
}
